

document.addEventListener("DOMContentLoaded", function () {
  const sectionContainer = document.querySelector("#hp-carousel");
  if (!sectionContainer) return;

  const tabs = sectionContainer.querySelectorAll(".hp-tab-trigger");
  const contents = sectionContainer.querySelectorAll(".hp-carousel-tab-content");
  const subtexts = sectionContainer.querySelectorAll(".hp-carousel-subtext");
  let splideInstances = {};
  let splideInstancesV2 = {};

  // Función para inicializar Splide en el tab activo
  function initSplideInTab(tabId) {
    const tabContent = sectionContainer.querySelector(`#${tabId}`);
    const splideEl = tabContent ? tabContent.querySelector(".hp-splide-carousel") : null;
    const splideElV2 = tabContent ? tabContent.querySelector(".hp-splide-carousel-v2") : null;
    
    if (splideEl && !splideInstances[tabId]) {
      // Reemplaza u optimiza estas opciones según el diseño de JH
      splideInstances[tabId] = new Splide(splideEl, {
        type: 'slide',
        perPage: 4,
        gap: '20px',
        pagination: false,
        arrows: false,
        drag: true,
        snap: true,
        trimSpace: false,
        breakpoints: {
          1164: {
            perPage: 3,
            arrows: true,
          },
          768: {
            perPage: 1,
            focus: 'center',
            padding: { left: '8px', right: '8px' },
            gap: '16px',
            arrows: true,
          },
        },
      }).mount();

      if(splideElV2 && !splideInstancesV2[tabId]) {
        splideInstancesV2[tabId] = new Splide(splideElV2, {
          type: 'slide',
          perPage: 4,
          gap: '20px',
          pagination: false,
          arrows: false,
          drag: true,
          snap: true,
          trimSpace: false,
          breakpoints: {
            1164: {
              perPage: 3,
              arrows: true,
            },
            768: {
              perPage: 1,
              focus: 'center',
              padding: { left: '8px', right: '8px' },
              gap: '16px',
              arrows: true,
            },
          },
        }).mount();
      }

    } else{ 
      if (splideInstances[tabId]) {
        // Si ya existe, refrescar posición por si cambió el layout de oculto a visible
        splideInstances[tabId].refresh();
      }
      if (splideInstancesV2[tabId]) {
        splideInstancesV2[tabId].refresh();
      }
    }
  }

  function refreshAllSplides() {
    Object.values(splideInstances).forEach((instance) => instance.refresh());
  }

  // Inicializar el primer tab por defecto
  const firstActiveTab = sectionContainer.querySelector(".hp-tab-trigger.is-active");
  if (firstActiveTab) {
    initSplideInTab(firstActiveTab.getAttribute("data-tab"));
  }

  window.addEventListener("resize", refreshAllSplides);

  // Lógica de clicks (Tabs)
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const targetTab = this.getAttribute("data-tab");

      // Remueve clases activas de triggers
      tabs.forEach(t => t.classList.remove("is-active"));
      this.classList.add("is-active");

      // Alternar subtextos dinámicos
      subtexts.forEach(st => st.classList.remove("is-visible"));
      const targetSubtext = sectionContainer.querySelector(`#subtext-${targetTab}`);
      if (targetSubtext) targetSubtext.classList.add("is-visible");

      // Alternar visibilidad de los contenedores del carrusel
      contents.forEach(content => {
        if (content.id === targetTab) {
          content.classList.add("is-active");
          initSplideInTab(targetTab);
        } else {
          content.classList.remove("is-active");
        }
      });
    });
  });
});
